import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

// v68.51 — reusable drawn-signature canvas. Calls onChange(dataUrl|null).
export default function SignaturePad({ onChange, testid = "signature-pad" }) {
  const ref = useRef(null);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2; ctx.lineCap = "round"; ctx.strokeStyle = "#1a1814";
    let drawing = false; let last = null;
    const pos = (e) => {
      const r = c.getBoundingClientRect(); const t = e.touches?.[0];
      return [((t ? t.clientX : e.clientX) - r.left) * (c.width / r.width), ((t ? t.clientY : e.clientY) - r.top) * (c.height / r.height)];
    };
    const down = (e) => { e.preventDefault(); drawing = true; last = pos(e); };
    const move = (e) => {
      if (!drawing) return;
      e.preventDefault();
      const p = pos(e);
      ctx.beginPath(); ctx.moveTo(...last); ctx.lineTo(...p); ctx.stroke();
      last = p; setHasInk(true);
    };
    const up = () => { if (drawing) onChange?.(c.toDataURL("image/png")); drawing = false; last = null; };
    c.addEventListener("mousedown", down); c.addEventListener("mousemove", move);
    c.addEventListener("touchstart", down); c.addEventListener("touchmove", move);
    window.addEventListener("mouseup", up); window.addEventListener("touchend", up);
    return () => {
      c.removeEventListener("mousedown", down); c.removeEventListener("mousemove", move);
      c.removeEventListener("touchstart", down); c.removeEventListener("touchmove", move);
      window.removeEventListener("mouseup", up); window.removeEventListener("touchend", up);
    };
  }, [onChange]);

  const clear = () => {
    const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setHasInk(false); onChange?.(null);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="overline">Draw your signature</label>
        <button type="button" onClick={clear} disabled={!hasInk} data-testid={`${testid}-clear`}
          className="text-[11px] text-[var(--ink-3)] hover:text-[var(--accent)] inline-flex items-center gap-1 disabled:opacity-40">
          <Eraser size={11} /> Clear
        </button>
      </div>
      <canvas ref={ref} width={720} height={180} data-testid={testid}
        className="w-full border border-[var(--border)] rounded-md bg-white cursor-crosshair touch-none" style={{ height: 160 }} />
    </div>
  );
}
